import React, {useContext, useEffect, useState} from "react";
import {DayToCompare, ExpressionMetric, Sign} from "../../../enums";
import {enumNamesToSelect, FormChips, Grid, FormHelperText, TextField} from "@leap4/frontend";
import {IDeltaParams} from "@leap4/entities-discrepancy-common";
import {AlertContext} from "../AlertContex";
import {urlService} from "../../../../../routing/urlsService";

const SignSelect = enumNamesToSelect(Sign);
const DayToCompareSelect = enumNamesToSelect(DayToCompare);
const MetricSelect = enumNamesToSelect(ExpressionMetric);

export const DeltaParamsForm = () => {
    const {alert, setAlert, dataPoints} = useContext(AlertContext);
    const alertParams = alert.params as IDeltaParams;
    const [availableDataPoints, setAvailableDataPoints] = useState([]);

    useEffect(() => {
        const relevantDataPoint = dataPoints.filter(point => point.type === "server");
        setAvailableDataPoints(relevantDataPoint)
    }, [dataPoints]);


    const updateAlertParams= (e) =>{
        setAlert({...alert, params: {...alert.params, [e.target.name]: e.target.value}})
    };
    const updateRelevantPlatforms = (relevantPlatforms: string[]) => {
        setAlert({...alert, params: {...alert.params, relevantPlatforms: relevantPlatforms}})
    }

    const getLinkToEditDatePoint = (dataPointId) => {
        return urlService.editDataPoint(dataPointId)
    }

    return <>
        <Grid container direction={"row"} justifyContent={"flex-start"} alignItems={"flex-start"} gap={"10px"}>
            <Grid item xs={3.8} md={3.8}>
                <FormHelperText>
                    Metric
                </FormHelperText>
                <MetricSelect
                    required
                    fullWidth
                    value={alertParams?.metric}
                    onChange={updateAlertParams}
                    name="metric"
                    style={{height:"43px"}}
                />
            </Grid>

            <Grid item xs={3.8} md={3.8}>
                <FormHelperText>
                    Sign
                </FormHelperText>

                <SignSelect
                    required
                    fullWidth
                    value={alertParams?.sign}
                    onChange={updateAlertParams}
                    name="sign"
                    defaultValue={Sign.POSITIVE}
                    style={{height:"43px"}}
                />
            </Grid>
            <Grid item xs={3.8} md={3.8}>
                <FormHelperText>
                    Percent
                </FormHelperText>
                <TextField
                    fullWidth
                    value= {alertParams?.percent}
                    onChange={updateAlertParams}
                    size="small"
                    variant="outlined"
                    name="percent"
                    className={"gridItem"}
                    style={{height:"43px"}}
                />
            </Grid>
        </Grid>

        <Grid container direction={"row"} justifyContent={"flex-start"} alignItems={"flex-start"} gap={"10px"}>
            <Grid item xs={3.8} md={3.8} style={{paddingTop: "10px"}}>
                <FormHelperText>
                    Day To Compare
                </FormHelperText>
                <DayToCompareSelect
                    required
                    fullWidth
                    value={alertParams?.day_to_compare}
                    onChange={updateAlertParams}
                    name="day_to_compare"
                    defaultValue={DayToCompare.ONE}
                    style={{height:"43px"}}

                />
            </Grid>

            <Grid item xs={3.8} md={3.8} style={{paddingTop: "13px"}}>
                <FormChips optionsList={availableDataPoints} valueKey={"_id"} labelKey={"name"}
                           onUpdateItems={updateRelevantPlatforms}
                           inputName={"Relevant Platforms"} enableCreate={false}
                           chips={[...(alert.params as any).relevantPlatforms]} link={getLinkToEditDatePoint} pureCreate={false}/>
            </Grid>

        </Grid>











    </>;
}